import './src/styles/global.css'

// /context paints from its own stylesheet, which a client-side route change would only add after the page has
// rendered. Links to it skip the router and load the page, so it shows styled from the first frame.
const FULL_LOAD = /^\/(fr\/)?context\/?$/

export const onClientEntry = () => {
    document.addEventListener("click", e => {
        const a = e.target.closest && e.target.closest("a[href]")
        if (!a || a.origin !== window.location.origin) return
        // Google Analytics' cross-domain linker adds _gl to links as they are pressed, which leaves it in the address bar of
        // every page a plain link loads (/context, the Context page's Book a demo). It is our own domain, so it comes off.
        if (/[?&]_gl=/.test(a.search)) {
            const url = new URL(a.href)
            url.searchParams.delete("_gl")
            a.href = url.href
        }
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return
        if (a.target && a.target !== "_self") return
        if (FULL_LOAD.test(a.pathname) && a.pathname !== window.location.pathname) e.stopPropagation()
        // The same goes for its in-page links (Book a demo): the router would count the new hash as a route change and
        // put the stylesheet back in the head, which drops the page's styles until it has loaded again. They scroll here
        // instead, and the URL takes the hash without a route change.
        const target = a.hash && a.pathname === window.location.pathname && a.closest("#ctx-embed")
            && document.getElementById(decodeURIComponent(a.hash.slice(1)))
        if (!target) return
        e.preventDefault()
        e.stopPropagation()
        window.history.replaceState(window.history.state, "", a.hash)
        target.scrollIntoView()
        target.focus({preventScroll: true})
    }, true)
}
